import { render } from "./Msg.vue?vue&type=template&id=a0eff74c&scoped=true"
import script from "./Msg.vue?vue&type=script&lang=js"
export * from "./Msg.vue?vue&type=script&lang=js"

import "./Msg.vue?vue&type=style&index=0&id=a0eff74c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0eff74c"]])

export default __exports__